define('model/ad.hoc.disclosee.model',['require','exports','module','fukit','./unit.model'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel = require('fukit').BaseModel,
      UnitModel = require('./unit.model');

  var AdHocDiscloseeModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureModel': '@constructor',
    },

    virtual: {
      unitName: {
        get: function() {
          var unitPersonListArray = this.get('unitPersonList').models;
          var units = [];
          for (var i = 0; i < unitPersonListArray.length; i++) {
            units.push(unitPersonListArray[i].get('name'));
          }

          return units.join(', ');
        },
      },
    },

    useHalSelfLinkAsUrl: false,

    urlRoot: '/api/v2/coi/adhoc/disclosee',

    childModels: {
      unitPersonList: UnitModel,
    },
  });

  module.exports = AdHocDiscloseeModel;
});

